module.exports = __webpack_public_path__ + "static/media/heart38.46fb9684.svg";